export default function getObjectSeriesAbbrBySn(objectList, targetSn) {
  for (let i = 0; i < objectList.length; i++) {
    if (objectList[i].sn === targetSn) {
      return objectList[i].seriesAbbr;
    }
  }
  return null;
}
